<template>
  <div>
    <div style="margin-bottom: 15px;">
      <el-date-picker v-model="startTime" type="datetime" placeholder="开始时间"
        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      <el-date-picker v-model="endTime" type="datetime" placeholder="结束时间" style="margin-left: 10px;"
        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      <span style="margin-left: 10px;float: right;">
        <el-input v-model="search" placeholder="请输入" style="width: 400px;" @change="searchData">
          <el-select v-model="searchKeyWords" slot="prepend" placeholder="请选择" style="width: 120px;">
            <el-option v-for="(option, index) in conditionList" :key="index" :value="option.type"
              :label="option.value"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </span>
    </div>
    <div style="flex: 1; overflow-y: auto; margin-bottom: 20px;background-color: white;padding: 10px;">
      <el-timeline v-if="logList && logList.length > 0">
        
        <el-timeline-item v-for="(item, index) in logList" :key="index" 
            :timestamp="item.time" placement="top" type="primary" size="large" hollow="true">
          <div style="font-size: 15px; margin-bottom: 5px;">
            <tr>
              <td><div style="margin-left: 20px;"><strong>IP地址: </strong></div></td>
              <td>{{ item.ip }}</td>
            </tr>
            <tr v-if="item.user && item.user != 'unknown'">
              <td><div style="margin-left: 20px;"><strong>用户: </strong></div></td>
              <td>{{ item.user }}</td>
            </tr>
            <tr>
              <td><div style="margin-left: 20px;"><strong>操作: </strong></div></td>
              <td>{{ item.desc }}</td>
            </tr>
            <tr v-if="item.param && item.param.length > 0">
              <td><div style="margin-left: 20px;"><strong>参数: </strong></div></td>
              <td>{{ item.param }}</td>
            </tr>
            <!-- <div style="width:200px;display: inline-block;"><strong>{{ item.time }}</strong></div> -->
            <!-- <div style="margin-left: 20px;"><strong>IP地址: </strong>{{ item.ip }}</div>
            <div style="margin-left: 20px;"><strong>用户: </strong>{{ item.user }}</div>
            <div style="margin-left: 20px;"><strong>操作: </strong>{{ item.desc }}</div> -->
          </div>
          <!-- <div style="color: #606266">
            {{ item.user }}{{ item.desc }}
          </div> -->
        </el-timeline-item>
      </el-timeline>
      <div v-else style="color: #606266; height: 100%; text-align: center; margin-top: 20px; padding: 10px">暂无数据</div>
    </div>

    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
    <!-- <div style="padding-top:10px;display: flex;justify-content: flex-end">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[20, 30, 40, 50]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="totalElement"></el-pagination>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Actionlogs",
  data() {
    return {
      logList: [],
      searchKeyWords: "all",
      search: "",
      conditionList: [
        {
          type: 'all',
          value: '全部'
        }, {
          type: 'user',
          value: '用户名'
        }, {
          type: 'ip',
          value: '用户ip'
        },
        {
          type: 'desc',
          value: '操作'
        }
      ],
      startTime: null,
      endTime: null,
      currentTime: null,
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList()
    },
    searchData() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      if (this.startTime == null && this.endTime == null) {
        this.endTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
        this.startTime = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1).Format('yyyy-MM-dd hh:mm:ss')
      } else if (this.startTime == null && this.endTime != null) {
        this.startTime = new Date(new Date(this.endTime).getTime() - 3600 * 1000 * 24 * 1).Format('yyyy-MM-dd hh:mm:ss')
      } else if (this.endTime == null && this.startTime != null) {
        this.endTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
      }
      this.showParam()
    },
    showParam() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        // spinner: 'el-icon-loading',
        background: 'rgba(55,55,55, 0.4)'
      });
      var data = {
        'pageNo': this.currentPage,
        'pageSize': this.pageSize,
        'startTime': this.startTime,
        'endTime': this.endTime,
        
      };
      if (this.searchKeyWords != "all") {
        let obj = {}
        obj[this.searchKeyWords] = this.search
        data["keyword"]= obj
      } else {
        data["condition"] = this.search
      }
     
      this.$axios.post(this.baseUrl3 + 'management3/operationLog/find', data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            if (data && data.total > 0) {
              this.logList = data.list;
              this.totalElement = data.total;
            }else{
              this.logList = []
              this.totalElement = 0
            }
            loading.close()
          } else {
            this.$message({ showClose: true, message: msg, type: 'error' });
            console.log(msg);
            loading.close()
          }
        })
        .catch(err => {
          console.log(err);
          loading.close()
        })
    },
  }
}
</script>

<style scoped>
.log-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.log-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: calc(33.333% - 20px);
  /* 三列布局 */
}
</style>
